<div class="filter-form">
  <formly-form (modelChange)="change()" [fields]="filter.getFields() | async" [form]="formFilter" [(model)]="filter.modelFeatures"/>

  @if (isCatalog) {
    <button (click)="reset()" [nbSpinner]="loading" class="submit" fullWidth i18n="@@Cancel" nbButton type="button">
      Очистить фильтры
    </button>
  } @else {
    <button (click)="submit()" [nbSpinner]="loading" class="submit" fullWidth i18n="@@Cancel" nbButton type="button" status="primary">
      Найти товары
    </button>
  }
</div>
